// ONYX-CUSTOM: Cuts zero decimals (,00) from prices formatted in the browser while onyx_hide_price_decimals is on.
(() => {
  const formatMoney = FoxTheme.Currency.formatMoney;

  FoxTheme.Currency.formatMoney = (cents, format) => formatMoney(cents, format).replace(/[.,]00(?!\d)/, '');
})();
